import React from 'react'
import MainLayout from '../components/layouts/MainLayout'
import { Text, useWindowSize } from '../modules/Dashboard'
import { Input } from '../styles/newStyles/Register.styled'
import { BiCopy } from 'react-icons/bi'
import { useCopyToClipboard } from '../core/hooks/useCopyToClipboard'
import telegramBotVideo from "../assets/images/WEBm/telegram-bot-tut.webm";
import { LAPTOP_SIZE, LAPTOP_SIZE_XL } from '../core/constants/common'


const TelegramBotPage = () => {
    const { copyToClip } = useCopyToClipboard()
    const { width } = useWindowSize()
    return (
        <MainLayout>
            <div className='min-h-[calc(100vh-11rem)] w-full'>
                <div className='flex flex-col gap-5 items-center sm:items-start justify-end  pb-10 relative lg:h-[530px]'>
                    <Text tid={"telegram-bot-title"} className='text-4xl text-center sm:text-start relative z-[2]' />
                    <Text tid={"telegram-bot-desc"} className='text-lg max-w-lg text-center sm:text-start relative z-[2] m' />
                    <div className='flex flex-col lg:flex-row gap-3 items-center justify-between w-full lg:max-w-[570px] 2xl:max-w-3xl bg-[#0300218C] backdrop-blur-sm rounded-2xl p-8 relative z-[2]'>
                        <div className='flex flex-col items-start gap-3 w-full'>
                            <Text tid={"Bot Access Codes"} />
                            <div className='flex items-center gap-1 w-full'>
                                <Input disabled value="https://t.me/Candlive_bot" className='!bg-[#271F37] !text-white !w-full sm:!max-w-[200px] 2xl:max-w-[420px]' />
                                <span className='bg-[#271F37] rounded-lg p-3 cursor-pointer' onClick={() => { copyToClip("https://t.me/Candlive_bot") }} >
                                    <BiCopy size={15} />
                                </span>
                            </div>
                            <ul className='space-y-2 mt-2'>
                                <li className=''>
                                    <Text tid={"how-to-connect"} />
                                </li>
                                <li className='ltr:ml-3 rtl:mr-3'>
                                    <Text tid="tele-bot-step-1" />
                                </li>
                                <li className='ltr:ml-3 rtl:mr-3'>
                                    <Text tid="tele-bot-step-2" />
                                </li>
                                <li className='ltr:ml-3 rtl:mr-3'>
                                    <Text tid="tele-bot-step-3" />
                                </li>
                            </ul>
                        </div>
                        <div className='mx-auto lg:mx-0 bg-[#8481BD] p-3 rounded-xl text-center space-y-2'>
                            <img src={require("../assets/images/telegram-qr.png")} alt='' width={220} height={260} className='lg:h-full object-contain rounded-xl' />
                            <Text tid={"Scan QR Code"} className='text-sm' />
                        </div>
                    </div>
                    <div className='hidden xl:block absolute ltr:right-3  2xl:ltr:right-[10%] rtl:left-3 2xl:rtl:left-[10%] top-1/2 -translate-y-1/2'>
                        <video
                            width={width >= 1480 ? 507 : 420}
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="metadata"
                            className='rounded-3xl'
                        >
                            <source src={telegramBotVideo} type="video/webm" />
                        </video>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

export default TelegramBotPage